export enum ShuffleStates {
  CANCELLED = "CANCELLED",
  COUNTDOWN = "COUNTDOWN",
  ERROR = "ERROR",
  EXECUTING = "EXEC",
  IN_PROGRESS = "IN_PROGRESS",
  SCHEDULED = "IS_SCHEDULED",
  SUCCESS = "SUCCESS",
}

export const DEFAULT_MIN_SHUFFLE_GROUP_SIZE = 1;
export const DEFAULT_SHUFFLE_GROUP_SIZE = 3;

export const COUNTDOWN_LENGTH = 30;
